export default {
    computed: {
        pricingVersions() { return this.$store.getters.pricingVersions },
        pricingRevisions() { return this.$store.getters.pricingRevisions },
        pricingPlans() { return this.$store.getters.pricingPlans },
        pricingProducts() { return this.$store.getters.pricingProducts },
        currentPricingVersion() { return this.$store.getters.pricingCurrentVersion },
        currentPricingRevision() { return this.$store.getters.pricingCurrentRevision },
        currentPricingPlan() { return this.$store.getters.pricingCurrentPlan },
        // computed
        pricingBasicProduct() { return this.pricingProducts.find(product => !product.dependencies.length) || false },
        pricingOptionalProducts() { return this.pricingProducts.filter(product => product !== this.pricingBasicProduct && !product.groups.length) },
        pricingOptionalProductsGrouped() { return this.pricingProducts.filter(product => product !== this.pricingBasicProduct && !!product.groups.length) },
        pricingOptionalProductsGroups() {
            return _.uniq(this.pricingProducts.filter(product => product !== this.pricingBasicProduct && !!product.groups.length).map(product => product.groups[0]));
        },
        pricingOptionalProductsSubscribable() { return this.pricingOptionalProducts.filter(product => product.subscribableByCustomer); },
        defaultPricingRevision() { return this.pricingRevisions.find(c => c.defaultRevision) },
        defaultPricingPlan() { return this.pricingPlans.find(p => p.plan == "YEARLY") || this.pricingPlans[0] },
        currentPricingRevisionObject() { return this.getPricingRevisionObject(this.currentPricingRevision) },
        isCurrentPricingMonthly() { return this.currentPricingPlan === 'MONTHLY' },
        isCurrentPricingYearly() { return this.currentPricingPlan === 'YEARLY' },
    },
    methods: {
        // GlobalPricing
        setPricingVersions(versions) { return this.$store.dispatch('defineCurrentPricingVersions', versions) },
        setPricingRevisions(revisions) { 
            return this.$store.dispatch('defineCurrentPricingRevisions', revisions)
            .then(() => {
                // current pricing revision is on the list ?
                if (null !== this.currentPricingRevision && undefined !== revisions.find(rev => rev.pricingVersionRevision == this.currentPricingRevision)) {
                    return;
                }
                // define default pricing revision
                return this.$store.dispatch('defineCurrentPricingRevision', this.defaultPricingRevision.pricingVersionRevision) 
            });
        },
        setPricingPlans(data) { 
            return this.$store.dispatch('defineCurrentPricingPlans', data)
            .then(() => {
                // current pricing plan is on the list ?
                if (null !== this.currentPricingPlan && undefined !== data.find(plan => plan.plan == this.currentPricingPlan)) {
                    return;
                }
                // define default pricing plan
                return this.$store.dispatch('defineCurrentPricingPlan', this.defaultPricingPlan.plan)
            });
        },
        setPricingProducts(data) { return this.$store.dispatch('defineCurrentPricingProducts', data) },
        setCurrentPricingVersion(data) { return this.$store.dispatch('defineCurrentPricingVersion', data) },
        setCurrentPricingRevision(data) { 
            if (this.pricingRevisions.length && undefined ==this.pricingRevisions.find(rev => rev.pricingVersionRevision === data)) {
                return this.$store.dispatch('defineCurrentPricingRevision', this.defaultPricingRevision.pricingVersionRevision) 
            }
            return this.$store.dispatch('defineCurrentPricingRevision', data) 
        },
        setCurrentPricingPlan(data) { 
            if (this.pricingPlans.length && undefined == this.pricingPlans.find(p => p.plan === data)) {
                return this.$store.dispatch('defineCurrentPricingPlan', this.defaultPricingPlan.plan)
            }
            return this.$store.dispatch('defineCurrentPricingPlan', data) 
        },
        // Getter
        getPricingRevisionObject(revision) { return this.pricingRevisions.find(rev => rev.pricingVersionRevision === revision) },
        getProductPlan(product, planCode) {
            if (!product || product === undefined) return {};
            return product.plans.find(plan => plan.code === planCode) || {};
        },
        getPricingPlanUnit(plan) { return plan === 'MONTHLY' ? this.$l10n.__('mois') : this.$l10n.__('an') },
        getCustomPricingAmountForProduct(product, planCode) {
            if (!this.getProductPlan(product, planCode).isCustomPricingAmountInCentsEnabled) return [];
            let amounts = [];
            this.getProductPlan(product, planCode).allowedCustomPricingAmountsInCents.forEach(amount => {
                amounts.push({
                    value: amount,
                    label: this.centsToCurrency(planCode === 'MONTHLY' ? amount : amount / 12)
                });
            });
            return amounts;
        },
        getPricingByPlan(price) {
            return (this.currentPricingPlan === 'YEARLY' ? price / 12 : price) / 100;
        },
        getProductAmount(product, planCode, withCustomPricing) {
            let plan = this.getProductPlan(product, planCode);
            if (plan === undefined) {
                return 0;
            } else if (product.customPricing !== undefined && (withCustomPricing == undefined || withCustomPricing)) {
                return product.customPricing;
            }
            return plan.amountInCents;
        },
        sortProducts(products) { return products.sort((a, b) => a.product.rank - b.product.rank) },
        getProductsGroupable(group) {
            return this.pricingOptionalProductsGrouped.filter(product => product.groups.includes(group));
        },
        getGroupedProductByCode(code) {
            return this.pricingOptionalProductsGrouped.find(product => product.code === code);
        }
    },
}
